import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FaEnvelope, FaWallet } from 'react-icons/fa6';
// eslint-disable-next-line import/no-unresolved
import { useAppKit } from '@reown/appkit/react';
import s from './style.css';
import { Button } from '../../components';
import { auth } from '../../actions';
import Input from '../../components/Input';
import { validateEmail } from '../../utils';
import { colors } from '../../foundations';
const AuthenticationForm = (props) => {
    const [email, setEmail] = useState('');
    const handleKeydown = (event) => {
        if (event.key === 'Enter') {
            handleButton();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [email]);
    useEffect(() => {
        if (props.walletVerified)
            props.handleWalletVerified({
                ethereumAddress: props.walletVerified,
                callback: () => props.setForm('walletPassword'),
                failCallback: () => props.setForm('qr'),
            });
    }, [props.walletVerified]);
    const handleButton = () => {
        if (validateEmail(email)) {
            props.requestEmailCode(email.toLowerCase(), () => props.setForm('code'), () => props.setForm('qr'));
        }
        else {
            alert('Invalid email!');
        }
    };
    const { open } = useAppKit();
    return (React.createElement("div", { className: s.formContainer },
        React.createElement("img", { src: 'https://firebasestorage.googleapis.com/v0/b/stiiick-1545628981656.appspot.com/o/sticknet-icon.png?alt=media&token=2b665dae-a63d-4884-a92e-59d5899530dc', className: s.sticknetIcon, alt: 'Sticknet Icon' }),
        React.createElement(Input, { placeholder: 'Your email', onChange: (e) => setEmail(e.target.value), style: { marginBottom: '12px' } }),
        React.createElement(Button, { text: 'Login with email', onClick: handleButton, id: 'continue', icon: React.createElement(FaEnvelope, { color: '#ffffff', size: 18 }) }),
        React.createElement("div", { className: s.separatorContainer },
            React.createElement("div", { className: s.line }),
            React.createElement("span", { className: s.orText }, "or"),
            React.createElement("div", { className: s.line })),
        React.createElement(Button, { text: 'Login with wallet', onClick: open, id: 'continue-wallet', icon: React.createElement(FaWallet, { color: '#ffffff', size: 18 }), style: { marginTop: 0, backgroundColor: colors.primary }, loadingDisabled: true }),
        React.createElement("button", { type: 'button', className: s.dont, onClick: () => props.setForm('qr') }, "Don't have an account")));
};
const mapStateToProps = (state) => ({
    country: state.appTemp.country,
    walletVerified: state.appTemp.walletVerified,
});
const connector = connect(mapStateToProps, { ...auth });
export default connector(AuthenticationForm);
